import React, { useContext } from 'react';
import {
  Card,
  CardBody,
  CardMedia,
  CardContent,
  Typography,
  Link,
  Skeleton,
  SkeletonBlock,
  SkeletonLine,
} from '@one-thd/sui-atomic-components';
import { StoreHeroContext } from '../../StoreHero.context';

const StoreHeroCurbside = () => {
  const { loading, store } = useContext(StoreHeroContext);
  const { flags } = store || {};
  const { curbsidePickupFlag } = flags || {};

  if (loading) {
    return (
      <Card
        grow
        className="sui-text-center sui-leading-tight sui-flex sui-items-center"
        data-component="StoreHeroCurbsidePlaceholder"
      >
        <Skeleton
          key="placeholder"
          data-component="StoreHeroCurbsidePlaceholder"
          className="sui-col-span-12 sui-flex sui-align-center sui-justify-center sui-flex-col"
        >
          <SkeletonBlock aspect="square" style={{ height: '100px', width: '100px', alignSelf: 'center' }} />
          <SkeletonLine variant="multi" numberOfLines={3} />
        </Skeleton>
      </Card>
    );
  }

  return (
    <Card
      grow
      data-component="StoreHeroCurbside"
      className="sui-text-center sui-leading-tight sui-flex sui-items-center"
    >
      {curbsidePickupFlag && (
        <CardContent
          disablePadding
          className="sui-flex sui-overflow-hidden sui-gap-1 sui-flex-col sui-flex sui-items-center"
        >
          <a href="https://www.homedepot.com/c/curbside_pickup">
            <CardMedia
              src="https://assets.thdstatic.com/images/v1/curbside.svg"
              alt="Car with trunk open and app"
              title="Car with trunk open and app"
            />
          </a>
          <CardBody>
            <div className="sui-font-w-bold sui-text-2xl sui-mt-3">Curbside Pickup with The Home Depot App</div>
            <div className="sui-text-lg">
              Order online, check in with the app, and we&apos;ll bring the items out to your vehicle.
            </div>
            <div className="sui-mt-4">
              <Link align="center" href="https://www.homedepot.com/c/curbside_pickup">
                <span data-testid="curbside-learn-more-button">Learn More About Curbside Pickup</span>
              </Link>
            </div>
          </CardBody>
        </CardContent>
      )}
      {!curbsidePickupFlag && (
        <div className="sui-flex sui-flex-col sui-justify-center">
          <Typography variant="h2">Upcoming Workshops</Typography>
          <CardContent>
            <Link
              underline="hover"
              variant="body-lg"
              href="https://www.homedepot.com/workshops/"
            >
              <span>View all Workshops</span>
            </Link>
          </CardContent>
        </div>
      )}
    </Card>
  );
};

StoreHeroCurbside.propTypes = {};

StoreHeroCurbside.defaultProps = {};

StoreHeroCurbside.displayName = 'StoreHeroCurbside';

export { StoreHeroCurbside };
